export function getVisibleHeightRatio(rect: DOMRect, viewportHeight: number): number {
    if (rect.height <= 0) return 0

    const visibleTop = Math.max(rect.top, 0)
    const visibleBottom = Math.min(rect.bottom, viewportHeight)
    return Math.max(0, visibleBottom - visibleTop) / rect.height
}
